<template>
  <CustDialogBox
    @closed="dialogOnCloseFn"
    :show="isShow"
    title="设置密码"
    width="500"
  >
    <template #content>
      <div class="dialog_box">
        <el-form
          ref="applyRuleFormRef"
          style="width: 100%"
          :model="applyForm"
          :rules="applyRules"
          label-width="300"
          label-position="top"
          require-asterisk-position="right"
        >
          <el-form-item label="手机号" prop="phone">
            <NumberInput
              :disabled="type == 'setting'"
              v-model="applyForm.phone"
              maxlength="11"
              placeholder="请输入手机号"
            >
            </NumberInput>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-row style="width: 100%">
              <el-col :span="17">
                <el-input
                  placeholder="请输入"
                  :maxlength="11"
                  v-model="applyForm.code"
                />
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="6">
                <el-button
                  style="width: 100%; font-size: 14px"
                  @click="sendCode"
                  :disabled="isCounting"
                  type="primary"
                >
                  {{ buttonText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="新密码" prop="newPassword">
            <el-input
              placeholder="请输入"
              :minlength="4"
              :maxlength="18"
              v-model="applyForm.newPassword"
              @input="
                applyForm.newPassword = applyForm.newPassword.replace(
                  /[\u4e00-\u9fa5]/g,
                  ''
                )
              "
            />
            <span style="color: #bd3124; font-size: 12px">
              密码建议设置字母+数字的混合密码
            </span>
          </el-form-item>
          <el-form-item label="再次输入密码" prop="password">
            <el-input
              placeholder="请输入"
              :minlength="4"
              :maxlength="18"
              v-model="applyForm.password"
              @input="
                applyForm.password = applyForm.password.replace(
                  /[\u4e00-\u9fa5]/g,
                  ''
                )
              "
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="dialog_footer">
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm(applyRuleFormRef)"
        >
          提交
        </el-button>
      </div>
    </template>
  </CustDialogBox>
</template>

<script setup>
import { ref } from 'vue'
import {
  login,
  getByUserName,
  sendSmsCode,
  smsLogin,
  resetPassword,
} from '@/api/login'
import { useUserStore } from '@/store/modules/user'
const userStore = useUserStore()
const emit = defineEmits(['closed', 'update:isShow'])
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  type: {
    type: String,
    default: 'setting',
  },
})
const loading = ref(false)
const applyRuleFormRef = ref()
const applyForm = reactive({
  phone: userStore.getUserInfo?.mobile ?? '',
  code: '',
  newPassword: '',
  password: '',
})
const applyRules = reactive({
  phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
  code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
  password: [
    {
      required: true,
      message: '密码不能为空',
      trigger: 'blur',
    },
    {
      min: 4,
      max: 18,
      message: '密码长度需在4到18位之间',
      trigger: ['blur', 'change'],
    },
  ],
  newPassword: [
    {
      required: true,
      message: '密码不能为空',
      trigger: 'blur',
    },
    {
      min: 4,
      max: 18,
      message: '密码长度需在4到18位之间',
      trigger: ['blur', 'change'],
    },
  ],
})
const countdown = ref(0)
const isCounting = ref(false)
let timer = null
const buttonText = computed(() => {
  return isCounting.value ? `${countdown.value}秒后重新获取` : '获取验证码'
})

const sendCode = async () => {
  if (isCounting.value) return
  if (applyForm.phone.trim().length != 11) {
    ElMessage.warning('请输入正确的手机号')
    return
  }
  if (!userStore.getTenant) {
    const tan = await getByUserName(applyForm.phone)
    userStore.setTenant(tan.data[0]?.id)
  }

  startCountdown()
  const res = await sendSmsCode({ mobile: applyForm.phone, scene: 23 })
  if (res.code == 0) {
    ElMessage.success('发送成功')
  }
}

const startCountdown = () => {
  isCounting.value = true
  countdown.value = 60

  timer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer)
      isCounting.value = false
    }
  }, 1000)
}
onBeforeUnmount(() => {
  clearInterval(timer)
})
const dialogOnCloseFn = () => {
  applyForm.value = {}
  emit('closed')
  emit('update:isShow', false)
}
const submitForm = async formEl => {
  if (applyForm.password != applyForm.newPassword) {
    ElMessage.warning('两次密码输入不一致')
    return
  }
  loading.value = true
  console.log(applyForm.value)
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      const res = await resetPassword({
        password: applyForm.newPassword,
        code: applyForm.code,
        mobile: applyForm.phone,
      })
      if (res.code == 0) {
        ElMessage.success('修改成功')
        dialogOnCloseFn()
      }
    }
  })
  loading.value = false
}
</script>

<style lang="scss" scoped>
.dialog_box {
  width: 100%;
  padding: 10px 0;
  box-sizing: border-box;
}
.dialog_footer {
  width: 100%;
  text-align: end;
  padding-bottom: 10px;
}
</style>
